module.exports = __webpack_public_path__ + "static/media/change-password.23e51fae.png";